const Client = () => import(/* webpackChunkName: "home" */ '../views/Client.vue')
const Signup = () =>
  import(/* webpackChunkName: "signup" */ '../views/Signup.vue')
const SignupVerify = () =>
  import(/* webpackChunkName: "signup" */ '../views/SignupVerify.vue')
const Login = () => import(/* webpackChunkName: "login" */ '../views/Login.vue')
const Forget = () =>
  import(/* webpackChunkName: "forget" */ '../views/Forget.vue')
const CreatePassword = () =>
  import(/* webpackChunkName: "createpassword" */ '../views/CreatePassword.vue')
const Redirect = () =>
  import(/* webpackChunkName: "notfound" */ '../views/Redirect.vue')
const RefreshToken = () =>
  import(/* webpackChunkName: "notfound" */ '../views/RefreshToken.vue')

const AuthRoute = [
  {
    path: '/client',
    name: 'client',
    component: Client,
  },
  {
    path: '/signup',
    name: 'signup',
    component: Signup,
  },
  {
    path: '/signup/verify',
    name: 'signupverify',
    component: SignupVerify,
  },
  {
    path: '/login',
    name: 'login',
    component: Login,
  },
  {
    path: '/forget',
    name: 'forget',
    component: Forget,
  },
  {
    path: '/create-password',
    name: 'createpassword',
    component: CreatePassword,
  },
  {
    path: '/redirect',
    name: 'redirect',
    component: Redirect,
  },
  {
    path: '/refresh-token',
    name: 'refreshtoken',
    component: RefreshToken,
  },
]

export default AuthRoute
